const SITE_URL = 'https://fenetre-paris15.fr';

export const localBusinessSchema = {
  '@context': 'https://schema.org',
  '@type': 'HomeAndConstructionBusiness',
  name: 'DF PRO – Réparation Fenêtre Paris 15',
  description: 'Réparation et entretien de fenêtres PVC, aluminium, bois, volets roulants et baies vitrées dans Paris 15ᵉ (75015). Intervention 24/48h, devis gratuit.',
  telephone: '+33187668155',
  areaServed: {
    '@type': 'City',
    name: 'Paris 15ᵉ',
    postalCode: '75015',
  },
  address: {
    '@type': 'PostalAddress',
    addressLocality: 'Paris',
    postalCode: '75015',
    addressRegion: 'Île-de-France',
    addressCountry: 'FR',
  },
  openingHoursSpecification: [
    { '@type': 'OpeningHoursSpecification', dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'], opens: '08:00', closes: '19:00' },
    { '@type': 'OpeningHoursSpecification', dayOfWeek: 'Saturday', opens: '09:00', closes: '14:00' },
  ],
  priceRange: '€€',
};

interface BreadcrumbItem {
  name: string;
  item?: string;
}

export function buildBreadcrumbSchema(items: BreadcrumbItem[]) {
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, idx) => ({
      '@type': 'ListItem' as const,
      position: idx + 1,
      name: item.name,
      ...(item.item ? { item: item.item } : {}),
    })),
  };
}

export function buildFaqSchema(faqs: { q: string; a: string }[]) {
  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((faq) => ({
      '@type': 'Question',
      name: faq.q,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.a,
      },
    })),
  };
}

export function buildServiceSchema(name: string, description: string) {
  return {
    '@context': 'https://schema.org',
    '@type': 'Service',
    name,
    provider: { '@type': 'HomeAndConstructionBusiness', name: 'DF PRO', telephone: '+33187668155' },
    areaServed: { '@type': 'City', name: 'Paris 15ᵉ', postalCode: '75015' },
    description,
  };
}

export function buildArticleSchema(headline: string, description: string, datePublished: string) {
  return {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline,
    author: { '@type': 'Organization', name: 'DF PRO' },
    publisher: { '@type': 'Organization', name: 'DF PRO' },
    datePublished,
    description,
  };
}

export function buildGraphSchema(...schemas: Record<string, unknown>[]) {
  return {
    '@context': 'https://schema.org',
    '@graph': schemas,
  };
}

export { SITE_URL };